<template>
  <div>
    <input
      :id="model.elementGuid"
      type="hidden"
      class="Form__Element FormHidden FormHideInSummarized"
      data-f-type="hidden"
      :name="model.elementName"
      :value="token"
    >
    <Recaptcha
      ref="recaptcha"
      :recaptcha-key="model.recaptchaKey"
      :container-id="`recaptcha-${model.elementGuid}`"
      :position="recaptchaPosition"
      @submit="recaptchaSubmit"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import Recaptcha from '@/components/Recaptcha.vue'
import useRecaptcha from '@/compositions/useRecaptcha'

export default {
  components: {
    Recaptcha
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const recaptchaPosition = window.document.dir == 'rtl' ? 'bottomright' : 'bottomleft'
    const token = ref('')
    const recaptcha = ref(null)
    const { registerInstance, unregisterInstance } = useRecaptcha()

    const recaptchaSubmit = async (tokenValue) => {
      token.value = tokenValue
      const form = document.getElementById(props.model.formGuid)
      const submitButton = form.querySelector('[type=submit]')
      submitButton.click()
    }

    onMounted(() => {
      registerInstance(
        props.model.elementName,
        () => token.value,
        () => recaptcha.value && recaptcha.value.verify()
      )
    })

    onUnmounted(() => {
      unregisterInstance(props.model.elementName)
    })

    return {
      recaptchaPosition,
      token,
      recaptcha,
      recaptchaSubmit
    }
  }
}
</script>
